import type { CSSProperties } from 'react';
import { isFacilityLogoMediaRef } from './media';
import type { ImageBlock } from "./types";

export const IMAGE_LAYOUT_CSS = {
  fillCol: 'email-img-fill-col',
  fixed: 'email-img-fixed',
  mobileFull: 'email-img-mobile-full',
  bgFallback: 'email-img-bg-fallback',
  bgTd: 'email-img-bg-td',
  emptyPlaceholder: 'email-img-empty-placeholder',
  loadingPlaceholder: 'email-img-loading-placeholder',
} as const;

export function isImageFillColumn(block: ImageBlock): boolean {
  return block.heightMode === 'fillColumn';
}

export function imageBackgroundTableClass(block: ImageBlock): string {
  return isImageFillColumn(block)
    ? IMAGE_LAYOUT_CSS.fillCol
    : IMAGE_LAYOUT_CSS.fixed;
}

export function imageUsesMobileFullWidth(
  block: Pick<ImageBlock, 'widthPx' | 'fullWidthMobile'>,
): boolean {
  return block.widthPx != null && block.fullWidthMobile;
}

export function imageOuterTableClass(block: ImageBlock): string | undefined {
  const classes = [
    imageUsesMobileFullWidth(block) ? IMAGE_LAYOUT_CSS.mobileFull : '',
    isImageFillColumn(block) ? IMAGE_LAYOUT_CSS.fillCol : '',
  ].filter(Boolean);
  return classes.length > 0 ? classes.join(' ') : undefined;
}

export function imageEditorBoxStyle(
  block: ImageBlock,
  fillColumnImage: boolean,
): CSSProperties | undefined {
  if (fillColumnImage) {
    return {
      flex: 1,
      height: '100%',
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
    };
  }
  if (isFacilityLogoMediaRef(block.media)) {
    return { width: '100%' };
  }
  return { width: '100%' };
}

export * from "./image-height";
